export type AnyURI = string;
export type FilterType = any;
export type NCName = string;
export type Duration = string;
